module.exports = __webpack_public_path__ + "static/media/profile-9.1d250b2c.png";